module.exports = __webpack_public_path__ + "img/1645.29d8a585.png";